import { render, staticRenderFns } from "./addBatch.vue?vue&type=template&id=29c8b3d6&scoped=true&"
import script from "./addBatch.vue?vue&type=script&lang=js&"
export * from "./addBatch.vue?vue&type=script&lang=js&"
import style0 from "./addBatch.vue?vue&type=style&index=0&id=29c8b3d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c8b3d6",
  null
  
)

export default component.exports